import React, {
    useState,
    useEffect,
    useContext
}
from "react";

import {
    useHistory
}
from "react-router-dom";

import {store}
from "../../../context/store";

import {functions}
from "../../../constants/common-functions";

import {
    COLOR_FOCUS
}
from "../../../constants/general-constants";

import {
    nonStandardUtilisationUrls
}
from "../../../constants/client-specifics";

import MobileHeader
from "../../home/mobile/components/MobileHeader";

import MobileUtilisationNavigator
from "./components/MobileUtilisationNavigator";

import "./MobileUtilisationSummaryOrganisation.css";


export default function MobileUtilisationSummaryOrganisation()
{
    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const queryContext =
        globalState?.state?.queryContext;

    const history =
        useHistory();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [organisations, setOrganisations] =
        useState([]);

    const [showMenu, setShowMenu] =
        useState(false);


    //--------------------------------------------------------
    // Initialisation
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(
                nonStandardUtilisationUrls.includes(
                    window.location.hostname
                )
            )
            {
                history.push(
                    "/utilisationallnonstandard/-100"
                );

                return;
            }
        },
        []
    );


    //--------------------------------------------------------
    // Load Departmental Summary
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            const filterBean = {};

            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/dashboard/utilisation/organisation",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                handleReturnObject
            );
        },
        [
            queryContext?.utilisationSurveyId
        ]
    );


    //--------------------------------------------------------
    // Results
    //--------------------------------------------------------

    const handleReturnObject =
        (obj) =>
        {
            if(
                obj &&
                obj.utilisationSummaryOrganisations
            )
            {
                setOrganisations(
                    obj.utilisationSummaryOrganisations
                );
            }
            else
            {
                setOrganisations([]);
            }
        };


    //--------------------------------------------------------
    // Metric
    //--------------------------------------------------------

    const Metric =
        ({
            title,
            value,
            color,
            percentage = true
        }) =>
        {
            return (

                <div
                    className="mobile-utilisation-department-metric"
                >

                    <div
                        className="mobile-utilisation-department-metric-marker"
                        style={{
                            backgroundColor:
                                color
                        }}
                    />

                    <div
                        className="mobile-utilisation-department-metric-title"
                    >
                        {title}
                    </div>

                    <div
                        className="mobile-utilisation-department-metric-value"
                    >
                        {
                            functions.formatNumber(
                                value,
                                percentage
                                    ? 1
                                    : 0
                            )
                        }

                        {
                            percentage
                                ? "%"
                                : ""
                        }

                    </div>

                </div>

            );
        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div className="mobile-utilisation-department-page">

            <MobileHeader
                openMenu={
                    () =>
                        setShowMenu(true)
                }
                openSearch={
                    () =>
                        console.log("SEARCH")
                }
            />


            <div
                className="mobile-utilisation-department-content"
            >

                {/*--------------------------------------------------
                    Heading
                --------------------------------------------------*/}

                <div
                    className="mobile-utilisation-department-heading"
                >

                    <div
                        className="mobile-utilisation-department-title"
                    >
                        Departmental Summary
                    </div>

                    <div
                        className="mobile-utilisation-department-subtitle"
                    >
                        Compare utilisation, occupancy and
                        workplace patterns across departments.
                    </div>

                </div>


                {/*--------------------------------------------------
                    Departments
                --------------------------------------------------*/}

                <div
                    className="mobile-utilisation-department-list"
                >

                    {
                        organisations.map(
                            (item, index) =>
                            (
                                <div
                                    className="mobile-utilisation-department-card"
                                    key={
                                        item.organisationId ||
                                        item.id ||
                                        index
                                    }
                                >

                                    <div
                                        className="mobile-utilisation-department-card-header"
                                    >

                                        <div
                                            className="mobile-utilisation-department-card-number"
                                        >
                                            {
                                                String(
                                                    index + 1
                                                )
                                                .padStart(
                                                    2,
                                                    "0"
                                                )
                                            }
                                        </div>

                                        <div
                                            className="mobile-utilisation-department-card-name"
                                        >
                                            {
                                                item.organisationName
                                            }
                                        </div>

                                    </div>


                                    <div
                                        className="mobile-utilisation-department-metrics"
                                    >

                                        <Metric
                                            title="FWS"
                                            value={item.focus}
                                            color={COLOR_FOCUS}
                                            percentage={false}
                                        />

                                        <Metric
                                            title="Utilised"
                                            value={item.utilised}
                                            color="#5f8ce9"
                                        />

                                        <Metric
                                            title="Desks Occupied"
                                            value={item.desksOccupied}
                                            color="#38A500"
                                        />

                                        <Metric
                                            title="Peak"
                                            value={item.peakMoment}
                                            color="#E92864"
                                        />

                                        <Metric
                                            title="Morning"
                                            value={item.morning}
                                            color="#f59e0b"
                                        />

                                        <Metric
                                            title="Afternoon"
                                            value={item.afternoon}
                                            color="#8b5cf6"
                                        />

                                        <Metric
                                            title="Non-Core"
                                            value={item.nonCore}
                                            color="#6b7280"
                                        />

                                        <Metric
                                            title="Week 1"
                                            value={item.week1}
                                            color="#0ea5e9"
                                        />

                                        <Metric
                                            title="Week 2"
                                            value={item.week2}
                                            color="#14b8a6"
                                        />

                                    </div>

                                </div>
                            )
                        )
                    }

                </div>

            </div>


            {/*--------------------------------------------------
                Utilisation Navigation
            --------------------------------------------------*/}

            <MobileUtilisationNavigator
                selected="department"
            />

        </div>

    );
}